import React from 'react';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';

import FlexTable from '../../../../../../components/FlexTable';

import { PhoneCell } from '../../../../../../components/FlexTable/components/cells/phone';

import {
  individual_column_style,
  individual_header_style
} from '../../../../../../assets/styles/table_custom_style';

export const ActiveWhatsappBlockListTableReport = ({
  data,
  setSortConfig,
  sortConfig
}) => {
  const createDynamicColumns = () => {
    const columns = [];

    columns.push(
      {
        dataField: 'telephone',
        text: 'Telefone',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, row) => <PhoneCell phone={row.telephone} ddi={row.ddi} />
      },
      {
        dataField: 'reason',
        text: 'Motivo do bloqueio',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, { reason }) => reason
      },
      {
        dataField: 'userName',
        text: 'Responsável',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, { userName }) => userName
      },
      {
        dataField: 'action',
        text: 'Ação',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, { action }) => action
      },
      {
        dataField: 'createdAt',
        text: 'Data/Hora',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, { createdAt }) => {
          return new Date(createdAt).toLocaleString('pt-BR', {
            timeZone: 'UTC'
          });
        }
      }
    );

    return [...columns];
  };

  const dynamicFunctionColumns = createDynamicColumns();

  return (
    <>
      <ToolkitProvider
        data={data || []}
        keyField="id"
        columns={dynamicFunctionColumns}
      >
        {(props) => (
          <div className="py-4 table-responsive">
            <FlexTable
              {...props.baseProps}
              entityName="activeWhatsappBlockReport"
              setSortConfig={setSortConfig}
              sortConfig={sortConfig}
            />
          </div>
        )}
      </ToolkitProvider>
    </>
  );
};
